import { FaUserCheck, FaUserClock, FaUserTie } from "react-icons/fa";

type Props = {
	total: number;
	activeCount: number;
	inactiveCount: number;
};

export const PersonalTrainerCard: React.FC<Props> = ({
	total,
	activeCount,
	inactiveCount,
}) => {
	return (
		<div className="bg-white rounded-xl shadow-md p-6 flex flex-col">
			<div className="flex items-center mb-4">
				<div className="p-3 bg-blue-100 rounded-lg">
					<FaUserTie className="text-blue-600 text-xl" />
				</div>
				<h2 className="ml-3 text-lg font-semibold text-gray-700">
					Personal Trainers
				</h2>
			</div>
			<div className="text-3xl font-bold text-gray-800 mb-2">{total}</div>
			<div className="flex justify-between mt-auto">
				<div className="flex items-center">
					<FaUserCheck className="text-green-500 mr-2" />
					<span className="text-sm text-gray-600">{activeCount} ativos</span>
				</div>
				<div className="flex items-center">
					<FaUserClock className="text-amber-500 mr-2" />
					<span className="text-sm text-gray-600">
						{inactiveCount} inativos
					</span>
				</div>
			</div>
		</div>
	);
};
